import { coreApi as api } from "../core/BaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiSearchSearch: build.query<
      GetApiSearchSearchApiResponse,
      GetApiSearchSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Search/search`,
        params: { keyword: queryArg.keyword },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiSearchSearchApiResponse =
  /** status 200 OK */ PerformanceCardSearchResultDto[];
export type GetApiSearchSearchApiArg = {
  keyword?: string;
};
export type PeriodDto = {
  id?: string | null;
  periodNo?: string | null;
  periodName?: string | null;
  startDate?: string;
  endDate?: string;
  startDateFirstManager?: string;
  endDateFirstManager?: string;
  startDateFirstCalibration?: string;
  endDateFirstCalibration?: string;
  startDateSecondCalibration?: string;
  endDateSecondCalibration?: string;
  companyGroupId?: string;
};
export type PerformanceSystemType = 1 | 2;
export type OkrDetailDto = {
  id?: string;
  okrShapeId?: string;
  okrRelationshipId?: string;
  okrTypeIds?: string[] | null;
  okrWeightId?: string;
  okrPrivacyId?: string;
  okrTransparencyId?: string;
  okrProgressId?: string;
  okrCompentencyAssessment?: boolean;
  minValue?: number;
  maxValue?: number;
};
export type KpiDetailDto = {
  id?: string;
  targetTypesIds?: string[] | null;
  kpiGoalEntryPersonKind?: string[] | null;
  kpiResultEntryPersonKind?: string[] | null;
  compentencyId?: string;
  /** KPI İlişkisi (Linkli / Linksiz). Boş = Linksiz (varsayılan). */
  kpiRelationshipId?: string | null;
};
export type KpiGoalCompentencyDetailsDto = {
  id?: string;
  performanceSystemId?: string;
  role?: string;
  goalPercentage?: number;
  competencyPercentage?: number;
  corporateGoals?: number;
  departmentGoals?: number;
  individualGoals?: number;
  managerialCompetencies?: number;
  coreCompetencies?: number;
};
export type ParameterType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25;
export type Parameter = {
  id?: string;
  parameterType?: ParameterType;
  companyGroupId?: string;
  companyId?: string;
  parameterGroup?: string | null;
  parameterValue?: string | null;
  parameterCode?: string | null;
};
export type OkrDetail = {
  id?: string;
  performanceSystemId?: string;
  okrShape?: Parameter;
  okrRelationship?: Parameter;
  okrType?: Parameter[] | null;
  okrWeight?: Parameter;
  okrPrivacy?: Parameter;
  okrTransparency?: Parameter;
  okrProgress?: Parameter;
  okrCompentencyAssessment?: boolean;
  performanceSystem?: PerformanceSystem;
};
export type KpiDetail = {
  id?: string;
  performanceSystemId?: string;
  targetTypes?: Parameter[] | null;
  compentency?: Parameter;
  kpiGoalEntryPersonKind?: Parameter[] | null;
  kpiResultEntryPersonKind?: Parameter[] | null;
  performanceSystem?: PerformanceSystem;
};
export type KpiGoalCompentencyDetails = {
  id?: string;
  performanceSystemId?: string;
  role?: Parameter;
  goalPercentage?: number;
  competencyPercentage?: number;
  corporateGoals?: number;
  departmentGoals?: number;
  individualGoals?: number;
  managerialCompetencies?: number;
  coreCompetencies?: number;
  performanceSystem?: PerformanceSystem;
};
export type RangeType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15;
export type PerformanceSystemRange = {
  id?: string;
  performanceSystemId?: string;
  rangeType?: RangeType;
  minValue?: number;
  maxValue?: number;
  performanceSystem?: PerformanceSystem;
};
export type PerformanceSystem = {
  id?: string;
  systemNumber?: string | null;
  systemName?: string | null;
  performanceSystemType?: PerformanceSystemType;
  okrDetails?: OkrDetail[] | null;
  kpiDetails?: KpiDetail[] | null;
  kpiGoalCompentencyDetails?: KpiGoalCompentencyDetails[] | null;
  performanceSystemRanges?: PerformanceSystemRange[] | null;
  strategicOKRs?: StrategicOkrMaster[] | null;
  companyId?: string;
};
export type Period = {
  id?: string;
  periodNo?: string | null;
  periodName?: string | null;
  startDate?: string;
  endDate?: string;
  startDateFirstManager?: string;
  endDateFirstManager?: string;
  startDateFirstCalibration?: string;
  endDateFirstCalibration?: string;
  startDateSecondCalibration?: string;
  endDateSecondCalibration?: string;
  companyId?: string;
};
export type StrategicOkrDetail = {
  id?: string;
  strategicOKRMasterId?: string;
  strategicOKRMaster?: StrategicOkrMaster;
  strategicOKR?: string | null;
  okrWeight?: number | null;
  targetSource?: string | null;
  targetResult?: string | null;
};
export type StrategicOkrMaster = {
  id?: string;
  companyId?: string;
  performanceSystemId?: string;
  performancePeriodId?: string;
  createdAt?: string;
  performanceSystem?: PerformanceSystem;
  performancePeriod?: Period;
  strategicOKRDetails?: StrategicOkrDetail[] | null;
};
export type PerformanceSystemRangeDto = {
  id?: string;
  rangeType?: RangeType;
  minValue?: number;
  maxValue?: number;
};
export type PerformanceSystemDto = {
  id?: string;
  systemNumber?: string | null;
  systemName?: string | null;
  performanceSystemType?: PerformanceSystemType;
  okrDetails?: OkrDetailDto[] | null;
  kpiDetails?: KpiDetailDto[] | null;
  kpiGoalCompentencyDetails?: KpiGoalCompentencyDetailsDto[] | null;
  strategicOKRs?: StrategicOkrMaster[] | null;
  performanceSystemRanges?: PerformanceSystemRangeDto[] | null;
  companyId?: string;
};
export type ScaleTypeDto = {
  scaleTypeId?: string;
  scaleTypeName?: string | null;
};
export type UserKrUpdateDto = {
  krId?: string;
  description?: string | null;
  progressUpdate?: number;
  createdDate?: string;
  userId?: string;
  creatorId?: string | null;
  okrTeamGroupId?: string | null;
};
export type UserKrDetailsDto = {
  krId?: string;
  description?: string | null;
  progress?: number;
  updates?: UserKrUpdateDto[] | null;
  isPrivate?: boolean;
  targetCompletionDate?: string;
  createdDate?: string;
  userId?: string;
  creatorId?: string | null;
  okrTeamGroupId?: string | null;
};
export type UserOkrStatus = 0 | 1 | 2;
export type UserOkrDetailsDto = {
  okrId?: string;
  description?: string | null;
  progress?: number;
  kRs?: UserKrDetailsDto[] | null;
  status?: UserOkrStatus;
  isPrivate?: boolean;
  createdDate?: string;
  isLinked?: boolean;
  targetCompletionDate?: string;
  categoryId?: string;
  weight?: number;
  creatorId?: string | null;
  teamGroupId?: string | null;
  teamList?: string[] | null;
  userId?: string;
  selectedStrategicOKRDetail?: string | null;
  selectedDepartmentOKRDetail?: string | null;
};
export type UserKpiDetailsDto = {
  kpiId?: string;
  title?: string | null;
  weight?: number | null;
  minResult?: number | null;
  targetResult?: number | null;
  maxResult?: number | null;
  minResultDate?: string | null;
  targetResultDate?: string | null;
  maxResultDate?: string | null;
  measurementUnitType?: string | null;
  measurementSourceId?: string | null;
  goalTypeParameterId?: string | null;
  calculationType?: string | null;
  kpiPoolItemId?: string | null;
  status?: number;
  createdDate?: string;
  creatorId?: string | null;
  result?: string | null;
  resultPoint?: number | null;
};
export type KpiPoolBriefDto = {
  goalId?: string;
  goalTitle?: string | null;
  id?: string;
  title?: string | null;
  goalTypeParameterId?: string;
  measurementSourceId?: string;
  calculation?: number | null;
  weight?: number;
  minResult?: number | null;
  targetResult?: number | null;
  maxResult?: number | null;
  minResultDate?: string | null;
  targetResultDate?: string | null;
  maxResultDate?: string | null;
  measurementUnitType?: string | null;
};
export type KpiCardApproveStatusDto = {
  addingSourceId?: string;
  approveStatus?: string | null;
  approveTurnId?: string | null;
  /** Son reddin gerekcesi. Kart yeniden gonderildiginde temizlenir; kalici
   *  kayit icin onay gecmisi ucuna (/history) bakilir. */
  note?: string | null;
  canSendToApproval?: boolean;
  canApprove?: boolean;
  canReject?: boolean;
};
export type PerformanceCardDetailsDto = {
  assignedId?: string;
  cardId?: string;
  cardAssignmentId?: string;
  cardName?: string | null;
  period?: PeriodDto;
  performanceSystem?: PerformanceSystemDto;
  scaleType?: ScaleTypeDto;
  createdDate?: string;
  okRs?: UserOkrDetailsDto[] | null;
  kpIs?: UserKpiDetailsDto[] | null;
  strategicOkrs?: StrategicOkrMaster;
  institutionalKpis?: KpiPoolBriefDto[] | null;
  departmentKpis?: KpiPoolBriefDto[] | null;
  kpiApproveStatus?: KpiCardApproveStatusDto;
  autoWhatId?: string | null;
  autoWhatScore?: number | null;
};
export type PerformanceCardSearchResultDto = {
  userId?: string;
  firstName?: string | null;
  lastName?: string | null;
  title?: string | null;
  titleName?: string | null;
  cardDetails?: PerformanceCardDetailsDto;
};
export const { useGetApiSearchSearchQuery, useLazyGetApiSearchSearchQuery } =
  injectedRtkApi;
